import Vue from 'vue';

export default {
    state:{
      firebase_config:{
        tokenfcm:null
      }
    },
    mutations: {
      tokenfcm(state,tokenfcm){
        state.firebase_config.tokenfcm=tokenfcm;
      }
    },
    actions: { 
      Definir_TokenFCM({commit,state},tokenfcm){
        commit('tokenfcm',tokenfcm);
      }
    },
    getters: {  
      getFirebase_Config(state){
        return state.firebase_config;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/firebase_config.js